/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageMinerDetail.vue?vue&type=template&id=5edc643f"
import script from "./pageMinerDetail.vue?vue&type=script&lang=js"
export * from "./pageMinerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports